// @flow

import { useNavigation } from '@react-navigation/native';
import * as React from 'react';
import {
    View, TextInput, useWindowDimensions,
} from 'react-native';
import { FormattedMessage, useIntl } from 'react-intl';
import { APIContext } from 'speed-js-react';
import { formatISO } from 'date-fns';
import AbsoluteActivityIndicator from 'src/components/AbsoluteActivityIndicator';
import MainWrapper from 'src/components/MainWrapper';
import Title from 'src/components/Title';
import StyledButton from 'src/components/StyledButton/StyledButton';
import { navigateWithoutHistory } from 'src/navigation/Stack';
import { commonStyles } from 'src/styles/common';
import Text from '../../components/CustomText/CustomText';
import styles from './CreateDeviceStyles';
import { EDIT_DEVICE_SCREEN } from '../constants';

const CreateDevice = () => {
    const intl = useIntl();
    const [values, setValues] = React.useState('');
    const [errors, setErrors] = React.useState(null);
    const createdAtRef = React.useRef(new Date());
    const [waitingForDevice, setWaitingForDevice] = React.useState(false);

    const { apiClient } = React.useContext(APIContext);
    const { width, height } = useWindowDimensions();
    const navigation = useNavigation();

    React.useEffect(() => {
        document.getElementById('page-description').setAttribute('content', `
        Добавяне и управление на устройства
        `);
    }, []);

    const handleSubmit = () => {
        const account = localStorage.getItem('account');

        createdAtRef.current = new Date();
        apiClient.resources.devices.authorise({ short_code: values, account_id: account }).then(() => {
            setWaitingForDevice(true);

            const checkDevice = () => {
                apiClient.resources.devices.list({
                    account_id: account,
                    modified__gte: formatISO(createdAtRef.current),
                }).then((res) => {
                    if (res.results.length) {
                        setWaitingForDevice(false);
                        navigateWithoutHistory(navigation, EDIT_DEVICE_SCREEN, { uuid: res.results[0].uuid });
                    } else {
                        setTimeout(checkDevice, 3000);
                    }
                });
            };
            checkDevice();
        }).catch((error) => {
            setErrors(error.data.short_code || error.data.non_field_errors);
        });
    };

    if (waitingForDevice) {
        return (
            <View style={{ width, height }}>
                <AbsoluteActivityIndicator />
            </View>
        );
    }

    return (
        <View>
            <MainWrapper homeButton>
                <Title text={(
                    <FormattedMessage
                        id="add-profile-to-device"
                        defaultMessage="Add Device"
                    />
                )}
                />
                <View style={width > 900 ? styles.wrapper : styles.wrapper_phone}>
                    <View style={styles.text_wrapper}>
                        <Text style={width > 600 ? styles.text : styles.text_phone}>
                            {intl.formatMessage({
                                id: 'enter_the_code_displayed_on_the_screen_of_the_device_you_want_to_add',
                                defaultMessage: 'Enter The Code Displayed On The Screen Of The Device You Want To Add.',
                            })}
                        </Text>
                    </View>
                    <View style={width > 900 ? styles.internal_wrapper : styles.internal_wrapper_phone}>
                        <TextInput
                            onSubmitEditing={handleSubmit}
                            onChangeText={(ch) => setValues(ch)}
                            style={width > 600 ? commonStyles.input : commonStyles.input_phone}
                            maxLength={16}
                            placeholder={intl.formatMessage({
                                id: 'security_code',
                                defaultMessage: 'Security Code',
                            })}
                        />
                        {errors && (
                            <View>
                                <Text style={commonStyles.error}>{errors}</Text>
                            </View>
                        )}
                    </View>
                    <StyledButton
                        handleSubmit={handleSubmit}
                        text={
                            <FormattedMessage id="save" defaultMessage="Save" />
                        }
                    />
                </View>
            </MainWrapper>
        </View>
    );
};

export default CreateDevice;
